export default __webpack_public_path__ + "static/media/Cadillac-White.d5ff698e.png";